// import { slider, textSizeToContentWidth, flexboxGapSupport } from "utility"; // see 28-08-2024 Update comment at end of this file.
import { slider, textSizeToContentWidth } from "utility";

require("./global/form/required-fix");
require("./global/form/datepicker-settings");

slider({
  containerClass: ".carousel",
  slidesClass: ".carousel__slides",
  slideClass: ".slide",
  currentSlideClass: ".slide--current",
  nextClass: ".carousel__paginate--next",
  prevClass: ".carousel__paginate--prev",
  currentPageClass: ".carousel__page--current",
  currentSlideProgressClass: ".slide__progress",
  grouped: false,
  slideAnimations: false,
  fixHeight: false,
});

((window) => {
  window.initMap = console.log;
  return window;
})(window);

textSizeToContentWidth(".card__title", ".card__body");

document.addEventListener("DOMContentLoaded", (e) => {
  if (document.querySelector("body").classList.contains("elementor-page")) {
    return;
  }

  [...document.querySelectorAll(".standalone-styles")].forEach((el) => {
    document.body.appendChild(el);
  });
});


/**
 * 28-08-2024 Update
 *
 * This has been commented out as it falsely flags the browser as not supporting flex properties
 * when viewing the AEOA child site as a visitor.
 * It's inconsistent, badly done and pointless as most browsers now support this.
 *
 * The css rules used are a mess and should also be removed if this script
 * proves to be pointless.
 */
// document.addEventListener(
//   "DOMContentLoaded",
//   (e) => !flexboxGapSupport() && document.body.classList.add("no-flex-gap")
// );

